import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import * as z from 'zod';

import { parseSchema } from '@repo/utils/parse-schema';

import { certificateSchema } from '~/services/certificate/types.ts';
import { http } from '~/services/http.ts';

const apiBase = `${import.meta.env.VITE_API_BASE}/certificate`;

const pagedCertificatesSchema = z.object({
  items: z.array(certificateSchema),
  pageNumber: z.number(),
  pageSize: z.number(),
  totalCount: z.number(),
  totalPages: z.number(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

async function getCertificates(projectId: string) {
  const response = await http(`${apiBase}/project/${projectId}/certificates`);

  return parseSchema(pagedCertificatesSchema, response).items;
}

export function queryCertificates(projectId: string) {
  return queryOptions({
    queryKey: ['certificates', projectId],
    queryFn: async () => getCertificates(projectId),
    placeholderData: keepPreviousData,
  });
}

export async function getCertificate(projectId: string, id: string) {
  const certificate = await http(`${apiBase}/project/${projectId}/certificates/${id}`);

  return parseSchema(certificateSchema, certificate);
}

export function queryCertificate(projectId: string, id: string) {
  return queryOptions(({
    queryKey: ['certificate', projectId, id],
    queryFn: async () => getCertificate(projectId, id),
    staleTime: 'static',
  }));
}
